import services from 'services';
import { TOUR_IDS } from './constants';
import { Appointments, Package, Patient, ReservationPackage, } from 'constants/resources';
export var canAccessTour = function (tourId) {
    var permissionService = services.permissionService;
    switch (tourId) {
        case 'reservation':
            return permissionService.hasPermissionToIndex(ReservationPackage);
        case 'package':
            return permissionService.hasPermissionToIndex(Package);
        case 'patientHistory':
        case 'patientProfile':
            return permissionService.hasPermissionToIndex(Patient);
        case 'appointment':
            return permissionService.hasPermissionToIndex(Appointments);
        case 'patientLog':
            return (permissionService.hasPatientLogPermission() &&
                permissionService.hasPermissionToIndex(Appointments));
        case 'inventory':
            return permissionService.hasAnyInventoryPermission();
        case 'financial':
            return permissionService.hasAnyFinanicePermission();
        default:
            return false;
    }
};
export var getAvailableTours = function () {
    return TOUR_IDS.filter(canAccessTour);
};
export var getInventoryTourRoute = function () {
    var permissionService = services.permissionService;
    if (permissionService.hasStockMovementPermission()) {
        return '/stock_movements';
    }
    if (permissionService.hasStockPermission()) {
        return '/stocks';
    }
    if (permissionService.hasProductPermission()) {
        return '/products';
    }
    if (permissionService.hasSupplierPermission()) {
        return '/suppliers';
    }
    if (permissionService.hasProductTypePermission()) {
        return '/product_categories';
    }
    return '/stock_movements';
};
export var getFinancialTourRoute = function () {
    var permissionService = services.permissionService;
    if (permissionService.hasTransactionPermission()) {
        return '/transactions';
    }
    if (permissionService.hasAccountPermission()) {
        return '/accounts';
    }
    if (permissionService.hasDocumentPermission()) {
        return '/documents';
    }
    if (permissionService.hasBalancePermission()) {
        return '/balances';
    }
    if (permissionService.hasFinancialPeriodPermission()) {
        return '/financial_periods';
    }
    if (permissionService.hasAccountTypePermission()) {
        return '/account_types';
    }
    return '/transactions';
};
export var getInventorySidebarTarget = function () {
    var permissionService = services.permissionService;
    if (permissionService.hasStockMovementPermission()) {
        return '[data-onboarding="sidebar-stock-movements"]';
    }
    if (permissionService.hasStockPermission()) {
        return '[data-onboarding="sidebar-stocks"]';
    }
    if (permissionService.hasProductPermission()) {
        return '[data-onboarding="sidebar-products"]';
    }
    if (permissionService.hasSupplierPermission()) {
        return '[data-onboarding="sidebar-suppliers"]';
    }
    return '[data-onboarding="sidebar-product-categories"]';
};
export var getFinancialSidebarTarget = function () {
    var permissionService = services.permissionService;
    if (permissionService.hasTransactionPermission()) {
        return '[data-onboarding="sidebar-transactions"]';
    }
    if (permissionService.hasAccountPermission()) {
        return '[data-onboarding="sidebar-accounts"]';
    }
    if (permissionService.hasDocumentPermission()) {
        return '[data-onboarding="sidebar-documents"]';
    }
    if (permissionService.hasBalancePermission()) {
        return '[data-onboarding="sidebar-balances"]';
    }
    if (permissionService.hasFinancialPeriodPermission()) {
        return '[data-onboarding="sidebar-financial-periods"]';
    }
    return '[data-onboarding="sidebar-account-types"]';
};
